import { render, staticRenderFns } from "./TackCoat.vue?vue&type=template&id=eab46804"
import script from "./TackCoat.vue?vue&type=script&lang=js"
export * from "./TackCoat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports